import flatten from "lodash/flatten";

import {loaderDisable, loaderEnable} from "../bvcomponents/ui/loaderView";
import {getCurrentLayout} from "../bvcomponents/appLayout";
import {getBathroomVisualizerData, getBvGroupFeatures, getBvGroups, getQtCategories} from "../api/server-api";
import Config from "../config";
import store from "../store";
import {setWizardIsActive} from "../actions/wizardFunctions";
import {addVisualizersLoaded, updateCanvasCount} from "../actions/actionFunctions";

export const loadAdditionalVisualizerGroups = async (visualizerType) => {
  switch (visualizerType) {
    case "bvLook": {
      const additionalFeatures = await Promise.all([
        getBvGroupFeatures("Decor", 0, 2000, [], "", "", null, false, visualizerType),
        getBvGroupFeatures("Attachment", 0, 2000, [], "", "", null, false, visualizerType),
        getBvGroupFeatures("Towel", 0, 2000, [], "", "", null, false, visualizerType),
      ]);
      // console.log("additionalFeatures", flatten(additionalFeatures));
      return flatten(additionalFeatures)
    }
    // to do add here Kitchen ? not sure
    default:
      return []
  }
}

export const shouldUseWizard = (mainResponse, qtCategoriesResponse) => {
  return (Array.isArray(qtCategoriesResponse) && qtCategoriesResponse.some(qtCat => qtCat.useWizard))
    // || !Array.isArray(qtCategoriesResponse) || !qtCategoriesResponse.length)
    && mainResponse && Array.isArray(mainResponse.wizardList) && mainResponse.wizardList.length > 0;
}

export const parseWizardResponse = (mainResponse, qtCategoriesResponse, visualizerType = null) => {
  const useWizard = shouldUseWizard(mainResponse, qtCategoriesResponse);
  store.dispatch(setWizardIsActive(useWizard, visualizerType));
}

const loadVisualizer = async (visualizerType) => {
  try {
    window.requestInProcess = true;
    loaderEnable();
    const layout = getCurrentLayout(visualizerType);
    const mainResponse = await Promise.all([
      getBathroomVisualizerData(30, true, visualizerType),
      getQtCategories(layout.getCurrentLayoutAbbreviation(), visualizerType)
    ]);
    if (Config.isDevMode()) {
      console.log('loadVisualizer mainResponse-->', mainResponse);
    }
    const groupsResponse = await getBvGroups(visualizerType);
    if (Config.isDevMode()) {
      console.log('loadVisualizer groupsResponse-->', groupsResponse);
    }
    const additionalFeatures = await loadAdditionalVisualizerGroups(visualizerType);
    layout.loadNewFeatures(Object.assign({}, mainResponse[0], {
      features: [...mainResponse[0].features, ...additionalFeatures]
    }));
    layout.setGroupsItemsCount(groupsResponse.data);
    // if (qtCategories.length) { //todo the most painful part // reactivate needed
    //   this.loadQtCategoriesFeatures(qtCategories); // load features from feature groups
    // }
    layout.createCustomConfigurations();
    layout.setGroupsItemsCount(groupsResponse.data); // not sure why we need it two items but ok, let it be
    layout.setDefaultFeatures();
    if (Array.isArray(mainResponse[1]) && mainResponse[1].length) {
      layout.setQtCategoriesSubparts(mainResponse[1]); // set QtCategories subParts(wait until defaults are set)
      // this.loadQtCategoriesFeatures(qtCategories); // load features from feature groups second time!!
      // after qtCategories are set (because we need partIdExistInQtCategory logic)
    }
    parseWizardResponse(mainResponse[0], mainResponse[1], visualizerType);
    // const needToLoadDefaultPreset = !document.kvConfig.jobId; // we should apply saved preset, we don't need the default one
    const needToLoadDefaultPreset = true; // we should apply this preset because if it's the first time - then it should apply
    if (needToLoadDefaultPreset && Array.isArray(mainResponse[0].defaults)) {
      const roomPreset = mainResponse[0].defaults.find(preset => preset.loadByTheDefault);
      if (roomPreset) {
        const layout_type = +roomPreset.layout_type;
        const needToChangeLayout = (layout_type || layout_type === 0) && (layout_type !== +layout.type);
        if (needToChangeLayout) {
          // await this.changeLayout(layout_type, true)
        }
        await layout.setItemsFromBvState(
          roomPreset, false, (bvState) => bvState, true, visualizerType
        )
      }
    }

    layout.initialized = true;
    console.log("new layout initialized", layout);
    window.requestInProcess = false;
    store.dispatch(addVisualizersLoaded(layout.visualizerType));
    store.dispatch(updateCanvasCount());

    return true

  } catch (error) {
    loaderDisable();
    console.log("error", error);
    return false
  }
}

export default loadVisualizer
